<template>
  <div>
    <div class="row">
      <div class="col-12">
        <chart-filters></chart-filters>
        <prison-tab-name class="mb-2"></prison-tab-name>
      </div>

      <div :class="compareMode ? 'col-6' : 'col-12'" v-if="filters.prisonGroupId && filters.before && filters.after">
        <call-stats key="call-stats-1" :filters="filters"></call-stats>
      </div>
      <div class="col-6" v-if="compareMode && !hideCompare">
        <call-stats key="call-stats-2" :filters="compareFilters"></call-stats>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import ChartFilters from '../components/chartFilters/ChartFilters.vue';
  import CallStats from '../components/charts/calls/CallStats.vue';
  import PrisonTabName from '../components/other/PrisonTabName.vue';

  export default {
    components: {
      ChartFilters,
      CallStats,
      PrisonTabName,
    },
    computed: {
      ...mapState({
        filters: state => state.stats.filters,
        compareFilters: state => state.stats.compareFilters,
        compareMode: state => state.stats.compareMode,
        hideCompare: state => state.stats.hideCompare,
      }),
    },
  }
</script>

<style>

</style>
